module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"instruction":"Hva er nummer","instruction2":"Dra og slipp riktig bilde"},"en":{"instruction":"What is number","instruction2":"Drag and drop the correct item"}}')
  delete Component.options._Ctor
}
